import { render, staticRenderFns } from "./rootRedirect.vue?vue&type=template&id=4e775660&"
import script from "./rootRedirect.vue?vue&type=script&lang=js&"
export * from "./rootRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports